export const ouraPdp = {
  hero: {
    heading: "The revolutionary smart ring",
    body: "Oura Ring 4 brings you closer to what matters most—your health. With an updated all-titanium design, this smart ring features Smart Sensing, a new sensing platform that doesn't just measure your biometrics but also adapts to you. It provides insights into over 50+ biometrics and wellness insights including sleep, readiness, activity, heart health, stress, metabolic health and women's health.",
  },
  accordions: {
    description: "Description",
    howItWorks: "How it works",
    sizing: "Sizing",
    subscription: "Subscription",
    techSpecs: "Tech specs",
    integrations: "Integrations",
    shippingAndReturns: "Shipping & returns",
    descriptionContent:
      "Oura Ring 4 is a smart ring, available in titanium or ceramic finishes, that transforms your sleep, activity, heart health, and recovery data into clear, actionable insights. With advanced sensors and Smart Sensing technology, it tracks 50+ biometrics and wellness insights around the clock so you can understand how your body is doing today and make choices that support your long-term health. When you choose to share these insights with your practitioner, they can use them to help personalize your care.",
    howItWorksStep1Title: "Purchase Oura Ring",
    howItWorksStep1Body:
      "After purchase, ŌURA will email you directly with information on the process of finding the best size for you.",
    howItWorksStep2Title: "Set up subscription",
    howItWorksStep2Body:
      "ŌURA will email you directly to set up your membership and connect your Oura Ring to your device.",
    howItWorksStep3Title: "Connect your Oura Ring to Fullscript",
    howItWorksStep3Body:
      "Take advantage of connecting your lifestyle data into Fullscript to give your practitioner a 360 view.",
    howItWorksStep4Title: "Wear your Oura Ring",
    howItWorksStep4Body: "Collect insights on your sleep, heart rate and more!",
    howItWorksStep5Title: "Have richer conversations with your practitioner",
    howItWorksStep5Body:
      "Save time during appointments by providing practitioners insight into your lifestyle data with your Oura Ring.",
    sizingStep1Title: "Purchase Oura Ring",
    sizingStep1Body:
      "After purchase, ŌURA will email you directly with information and mail a sizing kit.",
    sizingStep2Title: "Choose your finger",
    sizingStep2Body:
      "Your Oura Ring can be worn on any finger. We recommend the index, middle, or ring finger for optimal performance.",
    sizingStep3Title: "Test the fit",
    sizingStep3Body:
      "Your Oura Ring should fit snug and secure on your finger, but not to the point where it's uncomfortable. Try making a fist to ensure there are no gaps between the ring and the finger. Wear the sizing ring with the size number visible on top of the hand.",
    sizingStep3BodyNote:
      "Take your time to find the perfect fit, we recommend wearing your sizing ring for at least 24 hours before confirming your size.",
    sizingStep4Title: "Confirm your size",
    sizingStep4Body:
      "Once you're feeling good about the fit, confirm your size through your email from ŌURA. They will send the ring directly to you.",
    subscriptionContent:
      "Oura Membership unlocks the full potential of the Oura App, allowing you to access detailed insights and personalized guidance. Without a membership, the Oura Ring can be used only with limited functionality.",
    techSpecsSensorsTitle: "Sensors",
    techSpecsSensorsBullet1: "Red and infrared LEDs measure blood oxygen levels",
    techSpecsSensorsBullet2:
      "Green and infrared LEDs alternate to measure heart rate and heart rate variability 24/7 and respiration rate",
    techSpecsSensorsBullet3: "Digital sensor measures temperature trends",
    techSpecsSensorsBullet4: "Accelerometer tracks movement and activity 24/7",
    techSpecsWeightTitle: "Weight and Dimensions",
    techSpecsWeightBullet1: "Width: 7.90mm",
    techSpecsWeightBullet2: "Thickness: 2.88mm",
    techSpecsWeightBullet3: "Weight: 3.3 to 5.2 grams (depending on Oura Ring size)",
    techSpecsQualityTitle: "Quality materials",
    techSpecsQualityBullet1: "Non-allergenic titanium on inner & outer surfaces",
    techSpecsQualityBullet2: "Seamless titanium interior",
    techSpecsQualityBullet3: "Water resistant up to 100m/328 ft",
    techSpecsQualityBullet4: "Minor scratches from regular wear are normal",
    techSpecsCompatibilityTitle: "Compatibility",
    techSpecsCompatibilityBullet1:
      "Oura App is available in English, Finnish, Japanese, German, French, Spanish, Italian, Norwegian, Swedish, Czech, Dutch, and Danish",
    techSpecsCompatibilityBullet2: "Supports metric and imperial units of measurement",
    techSpecsCompatibilityBullet3: "Integrates with 40+ apps",
    techSpecsCompatibilityBullet4: "Available on iOS and Android",
    techSpecsBatteryTitle: "Battery life",
    techSpecsBatteryBullet1: "5-8 days of battery life*",
    techSpecsBatteryBullet2: "Typically charges in 20-80 minutes, depending on battery level",
    techSpecsConnectivityTitle: "Connectivity",
    techSpecsConnectivityBullet1: "Bluetooth Low Energy",
    techSpecsConnectivityBullet2: "Automatic firmware updates via Oura App",
    techSpecsConnectivityBullet3: "EMF-safe",
    techSpecsConnectivityBullet4: "Supports airplane mode",
    techSpecsConnectivityBullet5: "FCC-certified",
    techSpecsIncludedTitle: "What's included",
    techSpecsIncludedBullet1: "Oura Ring 4",
    techSpecsIncludedBullet2: "Size-specific charger",
    techSpecsIncludedBullet3: "USB-C cable",
    integrationsIntro:
      "Oura Ring integrates with hundreds of your favorite health and fitness apps.",
    integrationsListTitle: "Compatible apps include:",
    integrationsApp1: "Apple HealthKit",
    integrationsApp2: "Google Health Connect",
    integrationsApp3: "Headspace",
    integrationsApp4: "Strava",
    integrationsApp5: "Natural Cycles",
    integrationsApp6: "Mira App",
    integrationsApp7: "Myfitnesspal",
    integrationsApp8: "Cronometer",
    integrationsApp9: "Zero",
    integrationsApp10: "Apollo",
    integrationsApp11: "Talkspace",
    integrationsApp12: "Clue",
    integrationsApp13: "Thrive Global",
    integrationsApp14: "Noom",
    shippingAndReturnsIntro:
      "Standard shipping applies. Please contact <0>Fullscript Support</0> to request a return.",
    shippingAndReturnsDetails:
      "After your return is processed, you'll receive a prepaid shipping label directly from ŌURA. Please ship your ŌURA product back within 14 calendar days. Returns should include everything from the original purchase. You can use any packaging, as long as the items are protected and secured.",
  },
  marketing: {
    sleepAlt: "Person resting in bed with Oura Ring, representing sleep and recovery insights",
    movementAlt: "Person being active with Oura Ring, representing activity and movement tracking",
    heartAlt: "Oura Ring with heart rate visualization, representing heart health monitoring",
    instinctsAlt: "Person with Oura Ring, representing holistic health and body insights",
    sleepHeading: "All you have to do is sleep—the rest will follow",
    sleepBody:
      "Brighter moods, better energy, improved immunity—it all starts with sleep. Wake up to in-depth analysis about your sleep, so you can improve your habits and transform how you feel.",
    movementHeading: "Make every move count",
    movementBody:
      "Oura Ring 4 measures your daily movement (including steps, active calories, training frequency, and more) to create your Activity Score, which changes throughout the day based on how active you are. Your Activity Score ranges from 1-100 and helps you balance movement and recovery.",
    heartHeading: "Take your heart health into your own hands",
    heartBody:
      "The wellbeing of your heart is one of the most powerful contributors to your overall health and longevity. With ŌURA, tune in to how your heart is doing today so you can stay healthy long term.",
    instinctsHeading: "Here to help you trust your instincts",
    instinctsBody:
      "With ŌURA, you'll gain the tools to be the ultimate expert in your health. Spanning stress, sleep, your cycle, pregnancy, and more. Oura Ring 4 can provide revolutionary insights into your wellbeing to help you feel your best, every day.",
  },
  faq: {
    heading: "Frequently asked questions",
    q1: "How accurate is the Oura Ring?",
    a1Para1:
      "The sensors in the Oura Ring have been tested against laboratory results in multiple validation studies.",
    a1Para2: "See <0>The Pulse Blog for more on Oura in research and scientific studies</0>.",
    a1Para3:
      "Wearables differ in where they're worn, the sensors they use, and how they process data. For the most consistent and meaningful insights, it's best to track trends and changes over time within your Oura Ring and Oura App, rather than comparing your Oura results to those from other devices.",
    q2: "Can I wear my Oura Ring in pools, saunas, or ice baths?",
    a2: "The Oura Ring is water-resistant up to 100 meters (~330 feet), meaning that you can wear it while showering, swimming, or partaking in recreational diving (e.g. snorkeling), but we don't recommend using your ring while scuba diving or keeping it submerged underwater for over 12 hours. Chlorine will not damage it.\n\nOura Ring operating temperature ranges from \u201310\u201352\u00B0C / 14\u2013125\u00B0F. You can safely wear your ring in the shower, hot tubs, saunas, ice baths, and cryotherapy tanks. However, extended exposure to extreme temperatures (below \u201320\u00B0C / -4\u00B0F or above 60\u00B0C / 140\u00B0F) may lead to battery damage.",
    q3: "What does the Oura Ring track?",
    a3Intro: "Oura Ring gives a complete picture of your health, including:",
    a3Readiness: "Readiness",
    a3Sleep: "Sleep",
    a3Activity: "Activity",
    a3StressItem: "<0>Daytime Stress</0> and <1>Resilience</1>",
    a3HeartHealthItem:
      "Heart Health: <0>Cardiovascular Age</0> and <1>Cardio Capacity (VO2 Max)</1>",
    a3MetabolicHealthItem: "Metabolic Health: <0>Glucose</0> and <1>Meals</1>",
    a3WomensHealthItem:
      "Women's Health: <0>Cycle Insights</0>, <1>Fertile Window</1>, and <2>Pregnancy Insights</2>",
    q4: "Can I use Oura Ring without a subscription?",
    a4: "Oura Membership unlocks the full potential of the Oura App, allowing you to access detailed insights and personalized guidance. Without a membership, the Oura Ring can be used only with limited functionality.",
    q5: "How do I choose the right size for my Oura Ring?",
    a5: "We recommend you use an Oura Ring sizing kit before selecting your Oura Ring size. The kit includes plastic ring sizers corresponding to Oura Ring sizes, which differ slightly from standard ring sizes (note: half sizes are not available).\n\nFor accuracy, wear the sizing ring for at least 24 hours, including while sleeping, before finalizing your size. If you're between sizes, we recommend choosing the smaller size for a more secure fit.",
  },
} as const;
